export const SHOW_REGISTRATION_FORM_BUTTON_ID = "btnShowRegistrationForm";
export const SHOW_REGISTRATION_MODAL_BUTTON_ID = "btnShowRegistrationModal";
export const BACK_TO_CART_BUTTON_ID = "btnBacktoCart";
export const CHECKOUT_BUTTON_ID = "btnCheckout";
export const CART_WIDGET_CART_SUMMARY_ID = "wCartWidget__CartSummary";
export const CART_WIDGET_TITLE_ID = "wCartWidget__Title";
export const CART_WIDGET_LOGIN_TITLE_ID = "wCartWidget__LoginTitle";
export const CART_WIDGET_LOGIN_FORM_ID = "wCartWidget__LoginForm";
export const CART_WIDGET_REGISTRATION_TITLE_ID =
    "wCartWidget__RegistrationTitle";
export const CART_WIDGET_REGISTRATION_FORM_ID = "wCartWidget__RegistrationForm";
export const FORGOT_PASSWORD_DIV_CLASS_NAME = "divForgotPassword";

export function listenToAuthForms() {
    SaAuth.listenToLoginForm({
        onSuccess: () => {
            window.location.reload(); // Still on the cart
        },
        onError: (xhr) => {
            SaAlertUtils.defaultFireFromResponse("Login Error", xhr);
        },
    });

    SaAuth.listenToForgotPasswordForm({
        onSuccess: (message) => {
            SaAlertUtils.defaultFire("Password Reset", message);
        },
        onError: (xhr) => {
            SaAlertUtils.defaultFireFromResponse("Password Reset Error", xhr);
        },
    });

    SaAuth.listenToCreateAccountForm({
        requestingProcess: "StripeCheckout",
        onSuccess: () => {
            window.location.reload(); // Still on the cart
        },
        onError: (xhr) => {
            SaAlertUtils.defaultFireFromResponse(
                "Account Creation Failed",
                xhr,
            );
        },
    });

    $(`#${SHOW_REGISTRATION_FORM_BUTTON_ID}`).on("click", function () {
        $(`#${CART_WIDGET_CART_SUMMARY_ID}`).hide();
        $(`#${CART_WIDGET_TITLE_ID}`).hide();
        $(`#${CART_WIDGET_LOGIN_TITLE_ID}`).hide();
        $(`#${CART_WIDGET_LOGIN_FORM_ID}`).hide();
        $(`#${CHECKOUT_BUTTON_ID}`).hide();
        $(`#${CART_WIDGET_REGISTRATION_TITLE_ID}`).show();
        $(`#${CART_WIDGET_REGISTRATION_FORM_ID}`).show();
        $(`.${FORGOT_PASSWORD_DIV_CLASS_NAME}`).hide();
    });
    $(`#${SHOW_REGISTRATION_MODAL_BUTTON_ID}`).on("click", function () {
        $(`#${CART_WIDGET_CART_SUMMARY_ID}`).hide();
        $(`#${CART_WIDGET_TITLE_ID}`).hide();
        $(`#${CART_WIDGET_LOGIN_TITLE_ID}`).hide();
        $(`#${CART_WIDGET_LOGIN_FORM_ID}`).hide();
        $(`#${CHECKOUT_BUTTON_ID}`).hide();
        $(`#${CART_WIDGET_REGISTRATION_TITLE_ID}`).show();
        $(`#${CART_WIDGET_REGISTRATION_FORM_ID}`).show();
        $(`.${FORGOT_PASSWORD_DIV_CLASS_NAME}`).hide();
    });

    $(`#${BACK_TO_CART_BUTTON_ID}`).on("click", function () {
        $(`#${CART_WIDGET_REGISTRATION_TITLE_ID}`).hide();
        $(`#${CART_WIDGET_REGISTRATION_FORM_ID}`).hide();
        $(`#${CART_WIDGET_LOGIN_TITLE_ID}`).hide();
        $(`#${CART_WIDGET_LOGIN_FORM_ID}`).hide();
        $(`#${CART_WIDGET_TITLE_ID}`).show();
        $(`#${CART_WIDGET_CART_SUMMARY_ID}`).show();
        $(`#${CHECKOUT_BUTTON_ID}`).show();
        $(`.${FORGOT_PASSWORD_DIV_CLASS_NAME}`).hide();
    });
}
